export default {
	title: '气缸配置',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		save: '保存',
		cancel: '取消',
		confirm: '确定'
	},
	messages: {
		deleteSuccess: '删除成功',
		actionSuccess: '操作成功',
		requiredError: '必填项不能为空'
	},
	buttons: {
		add: '新增',
		batchDelete: '批量删除',
		edit: '修改',
		delete: '删除'
	},
	table: {
		phaseAngle: '相位角',
		cylinderNumber: '气缸编号',
		cylinderName: '气缸名称',
		diagnosisNumber: '诊断编号',
		deviceNumber: '设备编号',
		linkMass: '连杆质量（kg）',
		intakePressure: '名义进气压力（kPa）',
		outletPressure: '名义出气压力（kPa）',
		crankRadius: '曲轴半径',
		inertiaMass: '惯性质量（kg）',
		cylinderBoreDiameter: '气缸直径',
		pistonRodDiameter: '活塞杆直径',
		linkLength: '连杆长度（m）',
		pistonArea: '气缸活塞面积',
		poleArea: '活塞杆面积',
		action: '操作'
	},
	form: {
		placeholder: {
			projNo: '诊断编号',
			deviceNo: '设备编号',
			phaseAngle: '请输入',
			number: '请输入',
			linkMass: '请输入连杆质量',
			intakePressure: '请输入名义进气压力',
			outletPressure: '请输入名义出气压力',
			crankRadius: '请输入曲轴半径',
			inertiaMass: '请输入惯性质量',
			cylinderBoreDiameter: '请输入气缸直径',
			pistonRodDiameter: '请输入活塞杆直径',
			linkLength: '请输入连杆长度',
			pistonArea: '请输入气缸活塞面积',
			poleArea: '请输入活塞杆面积'
		},
		label: {
			phaseAngle: '相位角',
			number: '气缸编号',
			projNo: '诊断编号',
			deviceNo: '设备编号',
			linkMass: '连杆质量 (kg)',
			intakePressure: '名义进气压力 (kPa)',
			outletPressure: '名义出气压力 (kPa)',
			crankRadius: '曲轴半径',
			inertiaMass: '惯性质量 (kg)',
			cylinderBoreDiameter: '气缸直径',
			pistonRodDiameter: '活塞杆直径',
			linkLength: '连杆长度 (m)',
			pistonArea: '气缸活塞面积',
			poleArea: '活塞杆面积'
		}
	},
	config: {
		gridLayout: '格栅布局'
	},
	dialog: {
		add: '新增',
		update: '修改'
	}
}
